import React from "react";
import {constructVisitorInfo} from "../../interface/model/visitor";
import StuffInfoComponent from "./extends/stuff";
import EquipmentInfoComponent from "./extends/equipment";
import {CertificateInfo, EquipmentInfo, StuffInfo} from "../../interface/model/visitorExtends";
import {CertificateInfoComponent} from "./extends/certificate";

export default function VisitorInfoComponent({visitorInfos, setVisitorInfos, componentType, certificateFlag}) {

    function addVisitorInfoHandler() {
        setVisitorInfos(visitorInfos.concat([{visitorInfo:constructVisitorInfo}]));
    }

    function removeVisitorHandler(tmpKey) {
        setVisitorInfos(visitorInfos.filter((r, index) => tmpKey !== index));
    }

    function onChangeHandler(tmpKey, e) {
        setVisitorInfos(visitorInfos.map((row, index) =>
            tmpKey === index ? {...row, visitorInfo : {...row.visitorInfo, [e.target.name] : e.target.value}} : {...row} ));
    }

    function stuffSubmitHandler(tmpKey:number, stuffInfos:Array<StuffInfo>) {
        setVisitorInfos(visitorInfos.map((row, index) =>
            tmpKey === index ? {...row, visitorStuffInfos : stuffInfos} : {...row} ));
    }

    function equipmentSubmitHandler(tmpKey:number, equipmentInfo:EquipmentInfo) {
        setVisitorInfos(visitorInfos.map((row, index) =>
            tmpKey === index ? {...row, visitorEquipmentInfo : equipmentInfo} : {...row} ));
    }

    function certificateSubmitHandler(tmpKey:number, certificateInfo:CertificateInfo) {
        setVisitorInfos(visitorInfos.map((row, index) =>
            tmpKey === index ? {...row, visitorCertificateInfo : certificateInfo} : {...row} ));
    }

    return (
        <div className="nv_tablebox">
            <div className="nv_table_tit">
                <h2>방문자 정보</h2>
            </div>
            <div className="x_tablebox padding_0">
                <table className="nv_table">
                    <thead id="visitorThead">
                    <tr>
                        <th scope="row">방문자명</th>
                        <th scope="row">생년월일</th>
                        <th scope="row">연락처</th>
                        <th scope="row">회사명</th>
                        <th scope="row">차량번호</th>
                        {
                            certificateFlag ?
                            <th scope="row">수료증</th> : <></>
                        }
                        <th scope="row">중장비</th>
                        <th scope="row">반입물품</th>
                        { componentType === 1 && <th scope="row">VIP</th> }
                        <th scope="row">삭제</th>
                    </tr>
                    </thead>
                    <tbody>
                    {
                        visitorInfos.map((row, index) => (
                            <tr key={`visitorInfoKey-${index}`}>
                                <td>
                                    <input type='text'
                                           className="nv_input"
                                           name='name'
                                           placeholder="이름"
                                           value={row.visitorInfo.name}
                                           onChange={(e) => onChangeHandler(index, e)}
                                    />
                                </td>
                                <td>
                                    <input type='number'
                                           className="nv_input"
                                           name='birthDay'
                                           placeholder="생년월일(YYYYMMDD)"
                                           value={row.visitorInfo.birthDay}
                                           onChange={(e) => onChangeHandler(index, e)}
                                    />
                                </td>
                                <td>
                                    <input type='number'
                                           className="nv_input"
                                           name='phone'
                                           placeholder="연락처(숫자만입력)"
                                           value={row.visitorInfo.phone}
                                           onChange={(e) => onChangeHandler(index, e)}
                                    />
                                </td>
                                <td>
                                    <input type='text'
                                           className="nv_input"
                                           name='company'
                                           placeholder="회사명"
                                           value={row.visitorInfo.company}
                                           onChange={(e) => onChangeHandler(index, e)}
                                    />
                                </td>
                                <td style={{maxWidth: '120px'}}>
                                    <select name="carFlag" className="nv_select_box"
                                            onChange={(e) => onChangeHandler(index, e)}
                                            style={{width:'100px'}}
                                    >
                                        <option selected={(row.visitorInfo.carFlag || row.visitorInfo.carFlag === 'true') && true} value={'true'}>있음</option>
                                        <option selected={(!row.visitorInfo.carFlag || row.visitorInfo.carFlag === 'false') && true} value={'false'}>없음</option>
                                    </select>
                                    {
                                        (row.visitorInfo.carFlag || row.visitorInfo.carFlag === 'true') == 'true' &&
                                            <input type='text'
                                               className="nv_category_etc"
                                               name='car'
                                               placeholder="차량번호"
                                               value={row.visitorInfo.car}
                                               onChange={(e) => onChangeHandler(index, e)}
                                               style={{width:'100px'}}
                                            />
                                    }
                                </td>
                                {
                                    certificateFlag ?
                                    <td className={"check_icon_btn term_chek"}>
                                        <CertificateInfoComponent
                                            onClickHandler={(certificateInfo:CertificateInfo) => certificateSubmitHandler(index, certificateInfo)}
                                            certificateInfoData={row.visitorCertificateInfo}
                                        />
                                    </td> : <></>
                                }
                                <td className={"check_icon_btn term_chek"}>
                                    <EquipmentInfoComponent
                                        onClickHandler={(equipmentInfo:EquipmentInfo) => equipmentSubmitHandler(index, equipmentInfo)}
                                        equipmentInfoData={row.visitorEquipmentInfo}
                                    />
                                </td>
                                <td className={"check_icon_btn term_chek"}>
                                    <StuffInfoComponent
                                        onClickHandler={(stuffInfo:Array<StuffInfo>) => stuffSubmitHandler(index, stuffInfo)}
                                        stuffInfosData={row.visitorStuffInfos}
                                    />
                                </td>
                                {
                                    componentType === 1 &&
                                        <td>
                                            <select name="vipFlag" className="nv_select_box"
                                                    onChange={(e) => onChangeHandler(index, e)}
                                                    style={{width:'100px'}}
                                            >
                                                <option selected={(row.visitorInfo.vipFlag || row.visitorInfo.vipFlag === 'true') && true} value={'true'}>여</option>
                                                <option selected={(!row.visitorInfo.vipFlag || row.visitorInfo.vipFlag === 'false') && true} value={'false'}>부</option>
                                            </select>
                                        </td>
                                }
                                <td align='center'>
                                    {
                                        index !== 0 &&
                                            <button type="button"
                                                    className="nv_button_red minus"
                                                    onClick={() => removeVisitorHandler(index)}>삭제</button>
                                    }
                                </td>
                            </tr>
                        ))
                    }
                    </tbody>
                </table>
            </div>
            <div className="nv_btn_area">
                <button type="button"
                        className="nv_btn_blue add"
                        onClick={addVisitorInfoHandler}>
                    방문객 추가</button>
            </div>
        </div>
    )
}